export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");
	const hamburger = document.querySelector(".hamburger");
	const registerRemoveBtn = document.querySelector(".register-btn-group .remove-icon");
	const registerGroup = document.querySelector(".register-btn-group");


	try {

		$(".tooltip").tooltipster({
			contentCloning: true,
			maxWidth: 320,
			minWidth: 280,
			interactive: true,
			trigger:
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
					? "click"
					: "hover",
		});
	} catch (error) {

	}
	$(".home-network .item").on("mouseenter", function () {
		const targetPath = $(this).attr("hover-data");
		const $g = $('g.g-path.tooltip.tooltipstered[data-id="' + targetPath + '"]');

		// store original fill(s) so we can restore later
		$g.find('circle').each(function () {
			const $c = $(this);
			if (!$c.data('orig-fill')) $c.data('orig-fill', $c.attr('fill') || '');
		});

		// set circle fill to white
		$g.find('circle').attr('fill', '#EDF4EC');
	}).on("mouseleave", function () {
		const targetPath = $(this).attr("hover-data");
		const $g = $('g.g-path.tooltip.tooltipstered[data-id="' + targetPath + '"]');

		// restore original fill(s)
		$g.find('circle').each(function () {
			const $c = $(this);
			const orig = $c.data('orig-fill');
			if (typeof orig !== 'undefined') $c.attr('fill', orig);
		});
	});

	if (registerRemoveBtn) {
		registerRemoveBtn.addEventListener("click", (e) => {
			e.preventDefault();
			registerGroup.classList.toggle("is-active");
		});
	}

	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
		bodyWrap.classList.toggle("overlay-background");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-background");
	});

	//back to top
	backTop.addEventListener("click", (event) => {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "300");
	});
	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");


	//Tab function

	$(".mobile-menu-nav .menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});
	//Tab function
	$(".rolling-text").each(function () {
		const $element = $(this);
		const innerText = $element.text().trim();
		$element.empty();

		const createTextContainer = () =>
			$("<div>")
				.addClass("block")
				.append(
					[...innerText].map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter.trim() === "" ? "\xa0" : letter)
					)
				);

		$element.append(createTextContainer()).append(createTextContainer());
	});
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item .title").click(function () {
			if ($(this).parent().hasClass("is-toggle")) {

				$(this).parent().find(".article").slideUp();
				$(this).parent().removeClass("is-toggle");
			} else {
				$(".toggle-item").find(".article").slideUp();
				$(".toggle-item").removeClass("is-toggle");
				$(this).parent().find(".article").slideDown();
				$(this).parent().addClass("is-toggle");
			}
		});
	});

	$(".table-view-more").each(function () {
		// Initially show only first 10 rows
		$(this).find("tbody tr").slice(0, 10).show();

		// Hide button if there are 10 or fewer rows
		let size = $(this).find("tbody tr").length;
		if (size <= 10) {
			$(this).find(".ajax-btn-wrap").addClass("disble-btn");
		}

		// Click handler to show all rows and hide button
		$(this).find(".ajax-btn-wrap .btn-primary").on("click", function (e) {
			e.preventDefault();

			// Show all remaining rows
			$(this).parents(".table-view-more").find("tbody tr").slideDown();

			// Hide the button
			$(this).parent().addClass("disble-btn");
		});
	});
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: 120,
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".scroll-section-wrap .anchor-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					80 -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav  a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});

	//Tab function
	$(".tab-nav a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});
	//Tab hover

	$(".tab-select select").on("change", function () {
		var tab = $(this).val();
		var section = $(this).parents("section");
		// Target elements with both the ID and the specific class
		section.find(".tab-select-item").removeClass("is-active");
		section.find(".tab-select-item#" + tab).addClass("is-active");
	});
	$(".load-more-item-wrap").each(function () {
		const $wrap = $(this);
		const increment = parseInt($wrap.attr("item-amount"));
		const $cols = $wrap.find(".item");
		const $btn = $wrap.find(".btn-load-more");
		const $ajaxWrap = $wrap.find(".ajax-center-wrap");
		const total = $cols.length;
		$cols.slice(0, increment).css({ display: "flex" });
		if (total <= increment) {
			$ajaxWrap.addClass("disble-btn");
			return;
		}
		let visibleCount = increment;
		$btn.on("click", function (e) {
			e.preventDefault();
			visibleCount += increment;

			$cols.slice(0, visibleCount).slideDown().css({ display: "flex" });

			if (visibleCount >= total) {
				$ajaxWrap.addClass("disble-btn");
			}
		});
	});



	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	try {
		document.querySelectorAll('.wrap-form textarea').forEach(function (textarea) {
			textarea.value = textarea.value.trim();
		});
	} catch (error) {

	}

	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 200,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
